export default {
  methods: {
    setTableHieght(val) {
      return this.$store.state.contentViewHeight - val + 'px'
    },
    handleTimeCode() {
      const lastTime = this.$s.get('codeTime')
      const currentTime = new Date().getTime()
      if (lastTime) {
        return Math.floor(60 - (currentTime - lastTime) / 1000)
      } else {
        return 0
      }
    },
    resetTimeCode(fun) {
      const self = this
      const play = setInterval(() => {
        const time = self.handleTimeCode()
        if (time <= 0) {
          clearInterval(play)
          this.$s.remove('codeTime')
        }
        fun(time)
      }, 1000)
    }
  }
}
